"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "borgo-san-giovanni": {
    "7a384cc1": [{
      "hkey": "fc8bd9b8",
      "slug": "borgo-san-giovanni",
      "name": "Borgo San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "ca-dellacqua": [{
      "hkey": "fc8bd9b8",
      "slug": "borgo-san-giovanni",
      "name": "Borgo San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b69df3f5": [{
      "hkey": "fc8bd9b8",
      "slug": "borgo-san-giovanni",
      "name": "Borgo San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "colombera": [{
      "hkey": "fc8bd9b8",
      "slug": "borgo-san-giovanni",
      "name": "Borgo San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7cc9cae7": [{
      "hkey": "fc8bd9b8",
      "slug": "borgo-san-giovanni",
      "name": "Borgo San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "domodossolina": [{
      "hkey": "fc8bd9b8",
      "slug": "borgo-san-giovanni",
      "name": "Borgo San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "059f97da": [{
      "hkey": "fc8bd9b8",
      "slug": "borgo-san-giovanni",
      "name": "Borgo San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "frandellona": [{
      "hkey": "fc8bd9b8",
      "slug": "borgo-san-giovanni",
      "name": "Borgo San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7f34a80d": [{
      "hkey": "fc8bd9b8",
      "slug": "borgo-san-giovanni",
      "name": "Borgo San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "rita": [{
      "hkey": "fc8bd9b8",
      "slug": "borgo-san-giovanni",
      "name": "Borgo San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ef1f9b55": [{
      "hkey": "fc8bd9b8",
      "slug": "borgo-san-giovanni",
      "name": "Borgo San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "sacchelle": [{
      "hkey": "fc8bd9b8",
      "slug": "borgo-san-giovanni",
      "name": "Borgo San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;